import SmartGroupAddNotes from './smart-group-add-notes';
export default SmartGroupAddNotes;
